import { render, staticRenderFns } from "./marketplaceUpdate.vue?vue&type=template&id=ac9bb7cc&scoped=true&"
import script from "./marketplaceUpdate.vue?vue&type=script&lang=js&"
export * from "./marketplaceUpdate.vue?vue&type=script&lang=js&"
import style0 from "./marketplaceUpdate.vue?vue&type=style&index=0&id=ac9bb7cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9bb7cc",
  null
  
)

export default component.exports